import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Input } from '../../aura';
import { FormContextData, useFormContext } from '../../state';
import { useValidation } from './helpers/use-validation';

const MAX_LENGTH = 40;
export const firstNameRegex = /^[A-ZÀ-ÿ-,a-z. ]+$/;

export function FirstName(): JSX.Element {
  const { t } = useTranslation('input', { keyPrefix: 'firstName' });
  const {
    data: { firstName },
    setData,
  } = useFormContext();

  const hasValue = useCallback(
    (data: FormContextData) => (data.firstName ? null : 'FirstName is empty'),
    [],
  );

  const validate = useCallback((data: FormContextData) => {
    if (!data.firstName) {
      return 'FirstName is empty';
    }
    if (!data.firstName.match(firstNameRegex)) {
      return 'FirstName is invalid';
    }
    if (data.firstName.length > MAX_LENGTH) {
      return 'FirstName is too long';
    }
    return null;
  }, []);

  const extraInputProps = useValidation(t, hasValue, validate);

  const onValueChange = useCallback(
    (value: string) => {
      setData(current => ({ ...current, firstName: value }));
    },
    [setData],
  );

  return (
    <Input
      id="first-name"
      type="text"
      label={t('label')}
      value={firstName}
      onValueChange={onValueChange}
      autoComplete="given-name"
      maxLength={MAX_LENGTH}
      {...extraInputProps}
    />
  );
}
